export function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export function getDomainFromUrl(url) {
    const urlObj = new URL(url)
    return urlObj.hostname
}


export function getFiltersString(filters) {
    return filters.map(el => `${encodeURIComponent(el.id)}=${encodeURIComponent(el.value)}`).join('&')
}
